/**
 * One tick of merged keyboard + gamepad intent for the R2 path.
 *
 * The fields are mutable because R2InputController fills one snapshot in place
 * every tick rather than allocating: callers read it inside the tick and must
 * not retain it across ticks.
 */
export interface InputSnapshot {
  /** -1..1; a diagonal is normalized so the magnitude never exceeds 1. */
  moveX: number;
  moveY: number;
  /** Held for the whole of this tick. */
  fire: boolean;
  /** Rising edge against the previous tick. */
  firePressed: boolean;
  /** Falling edge against the previous tick. */
  fireReleased: boolean;
  /** The device that most recently produced a nonzero move or a fire. */
  source: 'keyboard' | 'gamepad';
}

export function createInputSnapshot(): InputSnapshot {
  return { moveX: 0, moveY: 0, fire: false, firePressed: false, fireReleased: false, source: 'keyboard' };
}

export function resetInputSnapshot(snapshot: InputSnapshot): void {
  snapshot.moveX = 0;
  snapshot.moveY = 0;
  snapshot.fire = false;
  snapshot.firePressed = false;
  snapshot.fireReleased = false;
}
